/**
 * Created by zc on 2017/10/19 0019.
 */
let _ = require('lodash');
function base64ToSrc(base64, defaultImage) {
  if (base64) return `data:image/png;base64,${base64}`;
  else return defaultImage;
}

module.exports = {
  base64ToSrc: base64ToSrc,
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/utils.js